export default function XSD_AnyAttribute() {
  return (
    <div>
      <h1>XSD_AnyAttribute</h1>
      <p>This is the XSD_AnyAttribute component.</p>
    </div>
  );
}